/** Apply pasted OTP digits into a 6-slot array (supports partial paste from any box). */
export function applyOtpPaste(currentOtp, startIndex, rawValue) {
  const digits = String(rawValue).replace(/\D/g, "");
  if (!digits) return { otp: currentOtp, focusIndex: startIndex, changed: false };

  if (digits.length === 1) {
    const otp = [...currentOtp];
    otp[startIndex] = digits;
    return {
      otp,
      focusIndex: startIndex < 5 ? startIndex + 1 : startIndex,
      changed: true,
    };
  }

  const otp = ["", "", "", "", "", ""];
  digits
    .slice(0, 6)
    .split("")
    .forEach((d, i) => {
      otp[i] = d;
    });
  const filled = Math.min(digits.length, 6);
  return {
    otp,
    focusIndex: filled >= 6 ? 5 : filled,
    changed: true,
  };
}

/** Handle clipboard paste event on an OTP input. */
export function handleOtpPasteEvent(e, currentOtp, startIndex = 0) {
  e.preventDefault();
  const pasted = e.clipboardData?.getData("text") ?? "";
  return applyOtpPaste(currentOtp, startIndex, pasted);
}
